export const state = () => ({
  lastPlayed: [],
  recentlyPlayed: []
})

export const mutations = {
  setLastPlayed(state, arr) {
    state.lastPlayed = arr || []
  },
  setRecentlyPlayed(state, arr) {
    state.recentlyPlayed = arr || []
  }
}

export const actions = {
  getLastPlayed(
    { commit, rootGetters },
    { game_id = '', errPage = false } = {}
  ) {
    if (!rootGetters.isLogin) {
      return Promise.reject(new Error('need login'))
    }
    return this.$request(
      'gameLatest',
      {
        body: { game_id }
      },
      { errPage }
    ).then((data) => {
      commit('setLastPlayed', data)
      return data
    })
  },
  getRecentlyPlayed(
    { commit, rootGetters },
    { game_id = '', errPage = false } = {}
  ) {
    if (!rootGetters.isLogin) {
      return Promise.reject(new Error('need login'))
    }
    return this.$request(
      'gameRecently',
      {
        body: { game_id }
      },
      { errPage }
    ).then((data) => {
      commit('setRecentlyPlayed', data)
      return data
    })
  }
}
